import { connect } from 'react-redux';
import Tiles from './../../components/Posts/Tiles';

const mapState = (state, props) => ({
  list: ( props.list ) ? props.list : state.posts.list
});

export default connect(mapState)(Tiles);
